export default "__VITE_ASSET__P5pPC9yj__"